/**
 * Case-insensitive filter over Warranty Rule products (title/variantTitle), used to
 * search the already-loaded "Selected Products" list without a server round-trip.
 *
 * @param {Array} products
 * @param {string} search
 * @return {Array}
 */
export const filterWarrantyProducts = (products, search) => {
  if (!Array.isArray(products)) return [];
  const term = (search || '').trim().toLowerCase();
  if (!term) return products;

  return products.filter((product) =>
    (product.title || '').toLowerCase().includes(term) ||
    (product.variantTitle || '').toLowerCase().includes(term),
  );
};
